import store from '@/store'

export default (to, from, next) => {
  const token = to.params.token

  // if (token) {
  	store.dispatch('setToken', token)
  	next()
  // } else {
  	// next('/error')
  // }
}
